import closeIcon from "include/images/dark-close-icon.svg";
import loadingIcon from "include/images/loader-grey.svg";
import emptyIcon from "include/images/nrf.svg";
import { useCallback, useEffect, useState } from "react";
import { Offcanvas } from "react-bootstrap";
import { msToHMS } from "utils/misc";
import userIcon from "include/images/user.png";

const AllUserEngagementFlyer = ({ topUsersByTimeSpent, loadMore, pagination, showModal, toggleModal }) => {
  const [loadingMore, setLoadingMore] = useState(false);
  const [scrollRef, setScrollRef] = useState(null);

  const handleLoadMore = useCallback(
    (entries) => {
      const target = entries[0];
      if (target?.isIntersecting) {
        if (!loadingMore && pagination?.currentPage < pagination?.totalPages) {
          setLoadingMore(true);
          const params = { page: pagination?.currentPage + 1 };
          loadMore(params, false, () => setLoadingMore(false));
        }
      }
    },
    [loadingMore, pagination, loadMore],
  );
  useEffect(() => {
    const options = {
      threshold: 0.2,
    };
    // Observer API
    const observer = new IntersectionObserver(handleLoadMore, options);

    if (observer && scrollRef) {
      observer.observe(scrollRef);
    }
    return () => {
      observer.disconnect();
    };
  }, [handleLoadMore, scrollRef]);

  return (
    <Offcanvas
      className={"offcanvas offcanvas-end custom-offcanvas-pannel"}
      show={showModal}
      onHide={toggleModal}
      id="rewardPannel"
      placement="right"
      name="rewardPannel"
      backdrop={true}
    >
      <Offcanvas.Header className="offCanvas-header-2">
        <div>
          <h5>User Engagement</h5>
        </div>
        <div className="btn_close pointer" data-bs-dismiss="offcanvas" aria-label="Close" onClick={toggleModal}>
          <img src={closeIcon} alt="" />
        </div>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <div className="fwc-body">
          <div className="table-responsive">
            {topUsersByTimeSpent?.length === 0 ? (
              <div className="fwc-body">
                <div className="no-record-found-container">
                  <div className="nfr-box">
                    <img src={emptyIcon} alt="No Record Found" />
                    <div className="nrf-text">
                      <h5>No Records Found!</h5>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <div className="table-responsive">
                <table className="table custom-table-striped">
                  <thead>
                    <tr>
                      <th>User</th>
                      <th>Total Time Spent</th>
                    </tr>
                  </thead>
                  <tbody>
                    {topUsersByTimeSpent?.map((user, index) => (
                      <tr
                        key={user?._id}
                        ref={(ref) => {
                          index === topUsersByTimeSpent.length - 1 &&
                            pagination?.currentPage < pagination?.totalPages &&
                            setScrollRef(ref);
                        }}
                      >
                        <td>
                          <span>
                            <div className="td-img-group d-flex align-items-start ">
                              <div className="td-img round-img m-right-2">
                                <img
                                  src={
                                    user?.user?.image ? process.env.REACT_APP_CDN + user?.user?.image?.small : userIcon
                                  }
                                  alt=""
                                />
                              </div>
                              <div>
                                {user?.user?.firstName} {user?.user?.lastName}
                                <br />
                                {user?.user?.userName} <br />
                                {user?.user?.telegramId}
                              </div>
                            </div>
                          </span>
                        </td>
                        <td>{msToHMS(user?.totalSpendTime)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
        {loadingMore && (
          <div className="w-100 d-flex justify-content-center load-more">
            <img src={loadingIcon} className="fa-spin" alt="" />
          </div>
        )}
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default AllUserEngagementFlyer;
